(function() {
    /* jshint validthis: true */
    "use strict";

    var recaptchaKey = "6LevCb4UAAAAALS3hwWg4_TKWRae7L_gxJaVSXGE";
    
    var lang = lang || document.documentElement.lang;
    var devMode = false;
    
    function initContactForm() {
        var $btn = $(".js-send-contact-form");
        if (devMode) {
            $("<div class='fs14 mb10'>Le reCaptcha et le formulaire sont desactives en environment developpement</div>").insertBefore($btn);
            return;
        }
        if ($btn.length && typeof grecaptcha === "object") {
            grecaptcha.ready(function() {
                $btn.each(function() {
                    var _ = this;
                    grecaptcha.render(_, {
                        'sitekey': recaptchaKey,
                        'callback': function (response) {
                            var $form = $(_).closest(".contact-form");
                            if ($form.hasClass("processing")) {
                                return;
                            }
                            if (chkReqFields($form[0])) {
                                if (!response || response === "") {
                                    $form.find(".errmsg-recaptcha").slideDown(200);
                                } else {
                                    $form.find(".errmsg-recaptcha").slideUp(200);
                                    $form.addClass("processing");

                                    ajax("/action/contactUs?ajax=true&captcha=" + response + "&" + $form.serialize(), function() {
                                        $form.removeClass("processing");
                                        $form[0].reset();
                                        grecaptcha.reset();
                                        $form.find(".form-fields").slideUp();
                                        $form.find(".sucmsg-sent").slideDown();
                                    }, true);
                                }
                            } else {
                                grecaptcha.reset();
                            }
                        },
                        'badge': 'inline'
                    });
                });
            });
        }
    }
    
    function initJobForm() {
        var $btn = $(".js-send-contact-job-form");
        if (devMode) {
            $("<div class='fs14 mb10'>Le reCaptcha et le formulaire sont desactives en environment developpement</div>").insertBefore($btn);
            return;
        }
        if ($btn.length && typeof grecaptcha === "object") {
            grecaptcha.ready(function() {
                $btn.each(function() {
                    var _ = this;
                    grecaptcha.render(_, {
                        'sitekey': recaptchaKey,
                        'callback': function (response) {
                            var $form = $(_).closest(".contact-job-form");
                            if ($form.hasClass("processing")) {
                                return;
                            }
                            if (chkReqFields($form[0])) {
                                if (!response || response === "") {
                                    $form.find(".errmsg-recaptcha").slideDown(200);
                                } else {
                                    $form.find(".errmsg-recaptcha").slideUp(200);
                                    $form.addClass("processing");

                                    if (!$form.find("input[name='ajaxForm']")[0]) {
                                        $form.append("<input type='hidden' name='ajaxForm' value='true'/>");
                                    }
                                    $form.find("input[name='captcha']").val(response);
                                    
                                    var fd = new FormData($form[0]);
                                    $.ajax({
                                        url: "/action/contactUsAttachmentDyn",
                                        method: "post",
                                        type: "post",
                                        data: fd,
                                        cache: false,
                                        contentType: false,
                                        processData: false,
                                        success: function (resData) {
                                            // Success
                                            $form.removeClass("processing");
                                            $form[0].reset();
                                            grecaptcha.reset();
                                            $form.find(".form-fields").slideUp();
                                            $form.find(".sucmsg-sent").slideDown();
                                        },
                                        error: function () {
                                            // Error
                                        },
                                        complete: function () {
                                            $form.removeClass("processing");
                                        }
                                    });
                                }
                            } else {
                                grecaptcha.reset();
                            }
                        },
                        'badge': 'inline'
                    });
                });
            });
        }
    }
    
    function initQuoteForm() {
        var $btn = $(".js-send-quote-form");
        if (devMode) {
            $("<div class='fs14 mb10'>Le reCaptcha et le formulaire sont desactives en environment developpement</div>").insertBefore($btn);
            return;
        }
        if ($btn.length && typeof grecaptcha === "object") {
            grecaptcha.ready(function() {
                $btn.each(function() {
                    var _ = this;
                    grecaptcha.render(_, {
                        'sitekey': recaptchaKey,
                        'callback': function (response) {
                            var $form = $(_).closest(".quote-form");
                            if ($form.hasClass("processing")) {
                                return;
                            }
                            if (chkReqFields($form[0])) {
                                if (!response || response === "") {
                                    $form.find(".errmsg-recaptcha").slideDown(200);
                                } else {
                                    $form.find(".errmsg-recaptcha").slideUp(200);
                                    $form.addClass("processing");
                                    
                                    //Making sure to fetch all values of multiple choice checkbox
                                    var field16 = $form.find("input[name = 'field16']");
                                    $form.find("input[name = 'services']").each(function () {
                                        if ($(this).is(":checked")) {
                                            field16.attr("value", field16.attr("value") + $(this).val() + ", ");
                                        }
                                    });
                                    
                                    ajax("/action/contactUs?ajax=true&captcha=" + response + "&" + $form.serialize(), function() {
                                        $form.removeClass("processing");
                                        $form[0].reset();
                                        grecaptcha.reset();
                                        $form.find(".form-fields").slideUp();
                                        $form.find(".sucmsg-sent").slideDown();
                                    }, true);
                                }
                            } else {
                                grecaptcha.reset();
                            }
                        },
                        'badge': 'inline'
                    });
                });
            });
        }
    }
    
    // Initiate
    DOMInit("complete", function(e) {
        // Comment the devMode assignation below to test in local
//        devMode = hasClass(qs("body"), "modeD");
        
        // Initiate contact button and recaptcha
        initContactForm();
        initJobForm();
        initQuoteForm();
    });

})();